import { HiAcademicCap } from "react-icons/hi2";

export const EducationIcon = ({ width, height, color, ...props }) => (
  <HiAcademicCap
    size={width || height || 16}
    color={color || "currentColor"}
    {...props}
  />
);
